import NoRecord from '@/components/Dialog/NoRecord.vue';
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { store } from '@/store';
import types from '@/store/types';

export function useNoRecord () {
  const shwoNoRecord = computed<boolean>({
    get: () => store.state.showNoRecord,
    set: (v) => store.commit(types.SET_SHOW_NO_RECORD, v),
  });
  const router = useRouter();

  function openNoRecord () {
    shwoNoRecord.value = true;
    router.replace({
      path: '/',
    });
  }

  return {
    NoRecord,
    shwoNoRecord,
    openNoRecord,
  };
}
